<template>
  <form class="searchKeyword" @submit="submitSearchKeyword">
    <div class="searchKeyword_input">
      <input
        type="text"
        :value="value"
        @input="updateValue"
        placeholder="キーワードで検索"
      />
    </div>
    <button type="submit" class="searchKeyword_btn">
      <img src="@/assets/images/icon/glass.svg" alt="" />
    </button>
  </form>
</template>

<script lang="ts">
import { SetupContext } from 'vue'

export default {
  name: 'searchKeyword',

  props: {
    value: {
      type: String,
      default: ''
    }
  },

  setup(props: any, context: SetupContext) {
    const updateValue = (e: any) => {
      context.emit('call-input-change', e.target.value)
    }

    const submitSearchKeyword = (ev: any) => {
      ev.preventDefault()

      context.emit('submit-keyword')
    }

    return {
      updateValue,
      submitSearchKeyword
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.searchKeyword {
  display: flex;

  &_input {
    display: block;
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: 0 10px;
    background-color: var.$color-white;
    border: 1px solid var.$color-border-gray;
    border-radius: 10px 0 0 10px;
    color: inherit;

    input {
      font-size: 1.6rem;
      transform: scale(0.875);
      width: 114.285%;
      transform-origin: left center;
    }
  }

  &_btn {
    flex: 0 0 60px;
    background-color: var.$color-main;
    width: 60px;
    height: 60px;
    border-radius: 0 10px 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
